<template>
    <div>
        <avue-crud :data="data" :option="option" :page.sync="page"  :search.sync="search" @current-change="changePage" @search-change="searchChange" @search-reset="resetChange">
            <template slot="menuBtn" slot-scope="scope">
                <el-dropdown-item  class="pull-down" @click.native="viewBtn(scope.row)" >查看</el-dropdown-item>
                <el-dropdown-item  class="pull-down" @click.native="extendBtn(scope.row)" >延期签署</el-dropdown-item>
            </template>
            <template slot="doc_title" slot-scope="scope" >
                <el-tooltip :content="scope.row.doc_title" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.doc_title }}</p>
                </el-tooltip>
            </template>
            <template slot="system_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.system_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.system_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="contract_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.contract_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.contract_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="all_signers" slot-scope="scope" >
                <el-tooltip :content="scope.row.all_signers" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.all_signers }}</p>
                </el-tooltip>
            </template>
        </avue-crud>
    </div>
</template>

<script>
    import { contractList, contractSearch, extensionContract } from '../../../api/contract';

    export default {
        name: "overdue",
        inject:['reload'],
        data() {
            return {
                page: {
                    currentPage: 1,
                    total: 60,  //总数
                    pageSize: 10, //每页多少
                    // pagerCount:5
                },
                data: [],
                doc_title:'',
                all_signers:'',
                pages:1,
                search:{
                    doc_title:'',
                    all_signers:''
                },
                option:{
                    menuType: 'menu',
                    menuBtnTitle:'操作',
                    align:'center',
                    menuAlign:'center',
                    editBtn:false,
                    delBtn:false,
                    menuWidth:150,//操作栏宽度设置
                    rowKey:'ids',
                    refreshBtn: false, //刷新按钮
                    columnBtn: false, //表格右侧操作列显隐的按钮
                    addBtn:false, //左上角新增
                    column:[
                        {
                            label:'合同名称',
                            prop:'doc_title',
                            search:true
                        }, {
                            label:'平台编号',
                            prop:'system_sn',
                        },
                        // {
                        //     label:'合同编号',
                        //     prop:'contract_sn',
                        // },
                        {
                            label:'发起人',
                            prop:'faqi_ren'
                        },  {
                            label:'发起时间',
                            prop:'faqi_time'
                        },  {
                            label:'参与人',
                            prop:'all_signers',
                            width:'500',
                            search: true
                        },  {
                            label:'合同状态',
                            prop:'ct_status_txt'
                        },  {
                            label:'合同完成时间',
                            prop:'finish_time'
                        },  {
                            label: '签署截止时间',
                            prop: 'expire_time'
                        }

                    ]
                },
            };
        },
        methods:{
            //分页
            changePage(num){
                if (this.doc_title==''&&this.all_signers==''){
                    contractList(7,10,num).then(res=>{
                        sessionStorage.setItem('overdue',num)
                        this.data=res.data.list
                        this.page.total=res.data.count
                    })
                }else {
                    //搜索后分页
                    contractSearch(7,10,num,this.doc_title,this.all_signers).then(res=>{
                        if (res.code==200){
                            sessionStorage.setItem('overdueSearch',num)
                            this.data=res.data.list
                            this.page.total=res.data.count
                        }
                    })
                }
            },
            //搜索
            searchChange(from,done){
                contractSearch(7,10,1,from.doc_title,from.all_signers).then(res=>{
                    this.doc_title=from.doc_title
                    this.all_signers=from.all_signers
                    if (res.code==200){
                        sessionStorage.setItem('overdueSearch',1)
                        sessionStorage.setItem('overdueParams',JSON.stringify(from))
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=1
                    }
                })
                done()
            },
            //重置搜索
            resetChange(){
                this.doc_title=''
                this.all_signers=''
                contractList(7,10,this.pages).then(res=>{
                    if (res.code==200){
                        sessionStorage.removeItem('overdue')
                        sessionStorage.removeItem('overdueSearch')
                        sessionStorage.removeItem('overdueParams')
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=1
                    }

                })
            },
            //查看
            viewBtn(row){
                this.$router.push({path:'/detailsPage',query:{id:row.id}})
            },
            //延期签署
            extendBtn(row){
                this.$confirm('新的签署截止时间将从当前时间向后延期90天，且仅支持延期一次 ', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    extensionContract({signer_list_id:row.id}).then(res=>{
                        if (res.code==200){
                            this.reload()
                            this.$message.success(res.msg)
                        }else {
                            this.$message.error(res.msg)
                        }
                    })
                }).catch(() => {

                });
            }
        },
        created() {
            if (sessionStorage.getItem('overdueSearch')){
                let overdueParams=JSON.parse(sessionStorage.getItem('overdueParams'))
                this.search=overdueParams
                this.doc_title=overdueParams.doc_title
                this.all_signers=overdueParams.all_signers
                contractSearch(7,10,sessionStorage.getItem('overdueSearch'),this.doc_title,this.all_signers).then(res=>{
                    if (res.code==200){
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=sessionStorage.getItem('overdueSearch')

                    }
                })
            }else {
                if (sessionStorage.getItem('overdue')===null){
                    contractList(7,10,this.pages).then(res=>{
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=1
                    })
                }else {
                    contractList(7,10,sessionStorage.getItem('overdue')).then(res=>{
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=sessionStorage.getItem('overdue')
                    })
                }
            }

        }
    }
</script>

<style scoped>
    /deep/.el-col{
        width: 25%;
    }
    /deep/.avue-form__menu{
        padding: 0px;
    }
    /deep/ .el-tabs__active-bar{
        background-color: #3d62f6;
    }
    .View{
        background: #3d62f6;
        color: #fff;
    }
    /deep/.el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }
    /deep/.el-icon-arrow-down {
        font-size: 15px;
    }
    .pull-down{
        padding: 5px 30px !important;
    }
    .textStyle{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: default;
        margin:0;
    }
    ::v-deep .avue-crud__menu{
        min-height:0px !important;
        height: 0px !important;
    }
</style>
